import { render, staticRenderFns } from "./TimeNow.vue?vue&type=template&id=38d5b9fa&scoped=true"
import script from "./TimeNow.vue?vue&type=script&lang=js"
export * from "./TimeNow.vue?vue&type=script&lang=js"
import style0 from "./TimeNow.vue?vue&type=style&index=0&id=38d5b9fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5b9fa",
  null
  
)

export default component.exports